export const DOC_URL = "https://docs.zeromagic.cloud/"
export const BLOG_URL = "https://docs.zeromagic.cloud/blog/introduction"
export const LEARN_URL = "https://docs.zeromagic.cloud/learn/"
export const REST_API = "https://docs.zeromagic.cloud/restapi/overview"
export const GRAPHQL = "https://docs.zeromagic.cloud/graphql/overview"
export const AUTHENTICATION = "https://docs.zeromagic.cloud/authentication/overview"
export const INTEGRATIONS = "https://docs.zeromagic.cloud/integrations/introduction"
export const MAGIC_AI = "https://docs.zeromagic.cloud/magic-ai"
export const YOUTUBE = "https://www.youtube.com/@zeromagic-cloud" 
export const GITHUB = "https://github.com/teamzeromagic/"

// export const WAITINGLIST_FORM = "https://forms.zohopublic.com/zeromagic/form/ZeromagicWaitlistForm/formperma/AgfMAJ7hBxvNYCAsKvd-OskB1AOol9hrUNig-l8nN4I"
export const WAITINGLIST_FORM =  "https://console.zeromagic.cloud/sign-in";
export const SIGN_UP = "https://console.zeromagic.cloud/sign-up"
